import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewStaySchedule extends React.Component{
  

  textFieldDidEndEditing(e) {
    this.props.delegate.changeStayCheckinAt(e.currentTarget.value);
  }
  
  render() {
    const stayCheckinAt = this.props.stayCheckinAt;
    const stayCheckoutAt = this.props.stayCheckoutAt;
    const reservation = this.props.reservation;
    const errors = this.props.errors;
    
    let strCheckinAt = null;
    if (stayCheckinAt != undefined) {
      strCheckinAt = stayCheckinAt.getFullYear() + '/'
                       + ("0" + (stayCheckinAt.getMonth() + 1)).slice(-2) + '/'
                       + ("0" + (stayCheckinAt.getDate())).slice(-2);
    } 
    
    let strCheckoutAt = null;
    if (stayCheckoutAt != undefined) {
      strCheckoutAt = stayCheckoutAt.getFullYear() + '/'
                       + ("0" + (stayCheckoutAt.getMonth() + 1)).slice(-2) + '/'
                       + ("0" + (stayCheckoutAt.getDate())).slice(-2);
    }
    
    return(
      <td>
        <div>
          <span className="ml5 mr5">チェックイン</span>
          <SMFormTextField
            name="stay_checkin_at"
            ref='stayCheckinAt'
            value={strCheckinAt}
            options={{className:'w110 js-datepicker', disabled: !SMReservationHelper.isDetailEditable(reservation)}}
            placeholderText='20151201'
            delegate={this} />
          <span className="ml5 mr5">チェックアウト</span>
          <SMFormTextField
            name="stay_checkout_at"
            ref='stayCheckoutAt'
            value={strCheckoutAt}
            options={{className:'w110 js-datepicker', disabled: !SMReservationHelper.isDetailEditable(reservation)}}
            placeholderText='20151201'
            delegate={this} />
          <span className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'schedules', errors)}</span>
          {this.props.delegate.renderCalendarLink()}
        </div>
      </td>
    );
  }
}

SMReservationEditViewStaySchedule.propTypes = {
  stayCheckinAt: PropTypes.string.isRequired,
  reservation: PropTypes.object.isRequired,
  stayCheckoutAt: PropTypes.string.isRequired,
  errors: PropTypes.array,
  delegate: PropTypes.object
};
  
export default SMReservationEditViewStaySchedule;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewStaySchedule.jsx